import { STATUS_LABEL, type AppointmentStatus } from "@cop/domain";

export function StatusPill({ status }: { status: AppointmentStatus }) {
  return (
    <span className="pill" data-status={status}>
      <span className="pill-dot" aria-hidden />
      {STATUS_LABEL[status]}
    </span>
  );
}

export const ACTION_LABEL: Partial<Record<AppointmentStatus, string>> = {
  pending_confirmation: "Pedir confirmación",
  confirmed: "Confirmar",
  arrived: "Marcar llegada",
  waiting: "Pasar a espera",
  in_treatment: "Iniciar atención",
  completed: "Finalizar",
  no_show: "No asistió",
  cancelled: "Cancelar turno",
};
